export function Item2() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6 underline">
        Cobrança extrajudicial:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Oferecemos serviços de master service para cobrança extrajudicial e
        judicial de créditos massificados ou não. Por meio de análise de dados
        avançada e levantamento de bens dos devedores, definimos estratégias
        personalizadas para as peculiaridades do cliente e dos créditos.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Utilizamos tecnologia de ponta para garantir maior eficácia nas
        cobranças e fornecemos relatórios detalhados com dashboards e
        indicadores estratégicos para facilitar a tomada de decisão.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4 underline">
        Cobrança judicial:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Somos parceiros dos melhores escritórios de advocacia do mercado, o que
        nos permite viabilizar uma cobrança judicial efetiva, utilizando-se de
        métodos inovadores e de uma visão diferenciada em processos de execução,
        ações monitórias, incidentes de desconsideração de personalidade
        jurídica, além de adotar medidas assertivas para combater práticas de
        blindagens e fraudes patrimoniais.
      </p>
    </>
  );
}
